import React, { createContext, useContext } from 'react';
import { useProfileData } from '../hooks/useProfileData';

const ProfileDataContext = createContext();

/**
 * ProfileDataProvider component that provides profile data management
 * to all child components. This ensures consistent profile data across
 * the application and enables real-time updates without page reloads.
 */
export const ProfileDataProvider = ({ children }) => {
  const profileData = useProfileData();

  return (
    <ProfileDataContext.Provider value={profileData}>
      {children}
    </ProfileDataContext.Provider>
  );
};

/**
 * Hook to access profile data from the ProfileDataProvider
 * @returns {Object} Profile data and management functions
 */
export const useProfileDataContext = () => {
  const context = useContext(ProfileDataContext);
  if (!context) {
    throw new Error('useProfileDataContext must be used within a ProfileDataProvider');
  }
  return context;
};

export default ProfileDataProvider;
